import { ReactElement } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

// Types
interface IProps {
  isOpen: boolean;
}

export const LoadingOverlay = (props: IProps): ReactElement => {
  const { isOpen } = props;

  return (
    <Backdrop sx={{ backgroundColor: '#bfcdd4', color: '#007bbd' }} open={isOpen}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
